import React, { useState, useEffect } from 'react';
import ListCard from '../components/ListCard';
import BillData from '../components/BillData';
import LoadingSpinner from '../components/LoadingSpinner';
import PaymentModal from '../components/PaymentModal';
import axios from 'axios';
import moment from 'moment';

function Home() {
	const queryParams = new URLSearchParams(window.location.search);
	const key = queryParams.get('key');

	const [billData, setBillData] = useState({});
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [loading, setLoading] = useState(false);
	const [loadingPdf, setLoadingPdf] = useState(false);

	useEffect(() => {
		if (key !== null) {
			fetchDueData();
		}
	}, []);

	const openModal = () => {
		setIsModalOpen(true);
	};

	const closeModal = () => {
		setIsModalOpen(false);
	};
	const pdfView = () => {
		setLoadingPdf(true);

		axios
			.post(
				'https://billing.waterboard.lk/EbillViewer/Api/Metering/Ebill_Viewer',
				{
					identityKey: key,
				},
				{
					headers: {
						'Access-Control-Allow-Origin': '*',
					},
				}
			)
			.then((response) => {
				setLoadingPdf(false);
				window.open(response?.data, '_blank');
			})
			.catch((error) => {
				setLoadingPdf(false);
				console.log('Response data:', error);
			});
	};

	const fetchDueData = () => {
		setLoading(true);
		axios
			.post(
				//'https://bis.waterboard.lk/OnlineBilling/Master/Link_Data',
				'https://billing.waterboard.lk/OnlineBilling/Master/Link_Data_Temp',
				{
					identityKey: key,
				},
				{
					headers: {
						'Access-Control-Allow-Origin': '*',
					},
				}
			)
			.then((response) => {
				setLoading(false);
				setBillData(response?.data);
			})
			.catch((error) => {
				setLoading(false);
				console.log('Response data:', error);
			});
	};

	function getMonthName(monthNumber) {
		const months = [
			'January',
			'February',
			'March',
			'April',
			'May',
			'June',
			'July',
			'August',
			'September',
			'October',
			'November',
			'December',
		];

		if (monthNumber >= 1 && monthNumber <= 12) {
			return months[monthNumber - 1];
		} else {
			return 'Invalid Month';
		}
	}

	const numberFormat = (value) => {
		return parseFloat(value)
			?.toFixed(2)
			.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
	};

	return (
		<div className='justify-center items-center font-roboto'>
			<div className='min-h-screen flex flex-col justify-center items-center bg-gray-100'>
				<div className='bg-white p-6 shadow-md rounded-md w-full max-w-md mt-4'>
					<LoadingSpinner loading={loading}>
						<div className='flex justify-center items-center'>
							<img
								src='https://ebis.waterboard.lk/wlogo.png'
								alt='Logo'
								className='w-20 h-20'
							/>
						</div>

						<p className='text-center font-semibold text-lg mt-2'>
							Account Number : {billData?.accountNo}
						</p>

						<p className='text-center text-sm mt-4 mb-4'>
							{billData?.name}
							<br />
							{billData?.address1}
							{billData?.address2}
							{billData?.address3}
						</p>
						<p className='text-center text-xs mt-4 text-black font-bold uppercase'>
							Billing Month : {billData?.billYear}{' '}
							{getMonthName(billData?.billMonth)}
						</p>
						<p className='text-center text-xs text-black rounded-xl'>
							Billing Date |{' '}
							{moment(billData?.currentDate).format('YYYY-MM-DD HH:mm:ss A')}
						</p>
						<div className='border-t border-dotted border-gray-200 my-4'></div>
						<p className='text-center text-sm mt-4 text-red-400'>
							Total amount due on last issued bill
						</p>

						<p className='text-4xl text-center  font-bold text-blue-600 mt-4'>
							{numberFormat(billData?.totalDue)} LKR
						</p>
						<p className='text-center mt-4 text-xs text-gray-400'>
							(Full or partial payments accepted)
						</p>

						<div className='flex justify-center mt-6 space-x-4'>
							<button
								className='bg-blue-500 hover:bg-blue-600 text-md font-bold text-white px-4 py-2 rounded-md flex items-center space-x-2'
								onClick={openModal}>
								<i className='fas fa-credit-card'></i>
								Pay Now
							</button>
							<button
								className='bg-green-300 hover:bg-green-400 text-black text-md font-bold px-4 py-2 rounded-md flex items-center space-x-2'
								onClick={pdfView}>
								{loadingPdf && (
									<div className='flex justify-center items-center'>
										<div class='flex justify-center items-center'>
											<div class='animate-spin rounded-full h-4 w-4 border-b-2 border-black mr-4 ' />
										</div>
									</div>
								)}
								View E-Bill
							</button>
						</div>

						<div className='border-t border-dotted border-gray-200 my-4'></div>

						<ListCard
							data={{
								//Outstanding: numberFormat(billData?.currentMonthCharge) + ' LKR',
								Consumption: billData?.currentConsumption + ' m³',
								'Monthly Bill':
									numberFormat(billData?.currentMonthCharge) + ' LKR',
								'Total Amount Due': numberFormat(billData?.totalDue) + ' LKR',
							}}
						/>
						<BillData />
					</LoadingSpinner>
				</div>

				<PaymentModal
					isOpen={isModalOpen}
					onClose={closeModal}
					data={billData}
				/>

				<div className='text-xs mt-4 text-center text-gray-500 mb-4'>
					Powered by
					<br />© 2023 National Water Supply & Drainage Board | IT Division
				</div>
			</div>
		</div>
	);
}

export default Home;
